// extracted by mini-css-extract-plugin
export default {"activeLink":"styles_activeLink__0Z8y5","icon":"styles_icon__4HlfX","label":"styles_label__qaQGE","link":"styles_link__l3abt","wrapper":"styles_wrapper__wpCcP"};